import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule, OverlayConfig } from '@angular/cdk/overlay';
import { BasePortalOutlet, CdkPortalOutlet, PortalModule, ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import { NgIf, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, HostBinding, ViewChild, ChangeDetectionStrategy, Component, NgModule, InjectionToken, Injector, Optional, SkipSelf, Inject, Injectable } from '@angular/core';
import * as i2 from '@aposin/ng-aquila/icon';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i3 from '@aposin/ng-aquila/button';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import * as i1 from '@angular/cdk/a11y';
import { Subject } from 'rxjs';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { take } from 'rxjs/operators';
const _c0 = ["closeButton"];
const _c1 = ["*"];
function NxMessageComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nx-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0._iconName);
  }
}
function NxMessageComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4, 0);
    i0.ɵɵlistener("click", function NxMessageComponent_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._emitCloseEvent());
    });
    i0.ɵɵelement(2, "nx-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r0.closeButtonLabel);
  }
}
function NxMessageBannerComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "nx-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0._iconName);
  }
}
function NxMessageBannerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4, 0);
    i0.ɵɵlistener("click", function NxMessageBannerComponent_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._emitCloseEvent());
    });
    i0.ɵɵelement(2, "nx-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r0.closeButtonLabel);
  }
}
const _c2 = "[_nghost-%COMP%]{font-size:var(--message-font-size);line-height:var(--message-line-height);font-weight:var(--message-font-weight);letter-spacing:var(--message-letter-spacing);color:var(--message-text-color);border-radius:var(--message-border-radius);width:100%;display:flex;align-items:flex-start;text-align:left;position:relative;border:1px solid;padding:23px}@media (max-width: 703px){[_nghost-%COMP%]{display:block}}[dir=rtl]   [_nghost-%COMP%]{text-align:right}[_nghost-%COMP%], .context-regular[_nghost-%COMP%]{border-color:var(--message-regular-border-color);background-color:var(--message-regular-background-color)}.context-info[_nghost-%COMP%]{border-color:var(--message-info-border-color);background-color:var(--message-info-background-color)}.context-info[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-info-icon-color)}.context-error[_nghost-%COMP%]{border-color:var(--message-error-border-color);background-color:var(--message-error-background-color)}.context-error[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-error-icon-color)}.context-success[_nghost-%COMP%]{border-color:var(--message-success-border-color);background-color:var(--message-success-background-color)}.context-success[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-success-icon-color)}.context-warning[_nghost-%COMP%]{border-color:var(--message-warning-border-color);background-color:var(--message-warning-background-color)}.context-warning[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-warning-icon-color)}@media screen and (forced-colors: active){.nx-message__icon[_ngcontent-%COMP%]{color:CanvasText}}.nx-message__icon[_ngcontent-%COMP%]{margin-right:16px}@media (max-width: 703px){.nx-message__icon[_ngcontent-%COMP%]{float:left;margin-right:8px}}[dir=rtl][_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{float:right;margin-right:initial;margin-left:16px}@media (max-width: 703px){[dir=rtl][_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{margin-left:8px}}.nx-message--closable[_nghost-%COMP%]{padding-right:47px}[dir=rtl]   .nx-message--closable[_nghost-%COMP%]{padding-right:23px;padding-left:47px}.nx-message__close-icon[_ngcontent-%COMP%]{position:absolute;top:16px;right:16px}[dir=rtl][_nghost-%COMP%]   .nx-message__close-icon[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-message__close-icon[_ngcontent-%COMP%]{right:auto;left:16px}";
function NxMessageToastComponent_ng_template_1_Template(rf, ctx) {}
function NxMessageToastComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.data.data, " ");
  }
}
const ICONS = {
  info: 'info-circle',
  error: 'exclamation-triangle',
  success: 'check-circle',
  warning: 'exclamation-circle-warning'
};
class NxMessageComponent {
  get _isInfo() {
    return this._context === 'info';
  }
  get _isSuccess() {
    return this._context === 'success';
  }
  get _isWarning() {
    return this._context === 'warning';
  }
  get _isError() {
    return this._context === 'error';
  }
  /**
   * Sets the context of the message.
   * The message box will color accordingly. Default: 'regular'.
   */
  set context(value) {
    this._updateContext(value);
  }
  get context() {
    return this._context;
  }
  /** Whether a message should have a close icon in order to be dismissed. */
  set closable(value) {
    const newValue = coerceBooleanProperty(value);
    if (newValue !== this._closable) {
      this._closable = newValue;
      this._cdr.markForCheck();
    }
  }
  get closable() {
    return this._closable;
  }
  /** Sets the label of the close button of the message. */
  set closeButtonLabel(value) {
    if (value !== this._closeButtonLabel) {
      this._closeButtonLabel = value;
      this._cdr.markForCheck();
    }
  }
  get closeButtonLabel() {
    return this._closeButtonLabel;
  }
  get _iconName() {
    const context = this._allowedContexts.includes(this._context) ? this._context : this._allowedContexts[0];
    return ICONS[context];
  }
  constructor(_cdr, _focusMonitor) {
    this._cdr = _cdr;
    this._focusMonitor = _focusMonitor;
    this._allowedContexts = ['regular', 'info', 'error', 'warning', 'success'];
    this._context = 'regular';
    this._closable = false;
    this._closeButtonLabel = 'Close dialog';
    /** Event emitted when the close icon of the message has been clicked. */
    this.closeEvent = new EventEmitter();
  }
  ngAfterViewInit() {
    if (this.closable) {
      this._focusMonitor.monitor(this._closeButton);
    }
  }
  ngOnDestroy() {
    this._focusMonitor.stopMonitoring(this._closeButton);
  }
  _emitCloseEvent() {
    this.closeEvent.emit();
  }
  _updateContext(value) {
    if (value !== this._context) {
      this._context = value;
      this._cdr.markForCheck();
    }
  }
  static {
    this.ɵfac = function NxMessageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMessageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxMessageComponent,
      selectors: [["nx-message"]],
      viewQuery: function NxMessageComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._closeButton = _t.first);
        }
      },
      hostVars: 10,
      hostBindings: function NxMessageComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("context-info", ctx._isInfo)("context-success", ctx._isSuccess)("context-warning", ctx._isWarning)("context-error", ctx._isError)("nx-message--closable", ctx.closable);
        }
      },
      inputs: {
        context: "context",
        closable: "closable",
        closeButtonLabel: "closeButtonLabel"
      },
      outputs: {
        closeEvent: "close"
      },
      exportAs: ["nxMessage"],
      ngContentSelectors: _c1,
      decls: 4,
      vars: 2,
      consts: [["closeButton", ""], ["size", "s", "aria-hidden", "true", 1, "nx-message__icon", 3, "name"], ["nxPlainButton", "", "tabindex", "0", "type", "button", 1, "nx-message__close-icon"], [1, "nx-message__content"], ["nxPlainButton", "", "tabindex", "0", "type", "button", 1, "nx-message__close-icon", 3, "click"], ["name", "close", "size", "s", "aria-hidden", "true"]],
      template: function NxMessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NxMessageComponent_Conditional_0_Template, 1, 1, "nx-icon", 1)(1, NxMessageComponent_Conditional_1_Template, 3, 1, "button", 2);
          i0.ɵɵelementStart(2, "div", 3);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx._iconName ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.closable ? 1 : -1);
        }
      },
      dependencies: [NxIconModule, i2.NxIconComponent, NxButtonModule, i3.NxPlainButtonComponent],
      styles: ["[_nghost-%COMP%]{font-size:var(--message-font-size);line-height:var(--message-line-height);font-weight:var(--message-font-weight);letter-spacing:var(--message-letter-spacing);color:var(--message-text-color);border-radius:var(--message-border-radius);width:100%;display:flex;align-items:flex-start;text-align:left;position:relative;border:1px solid;padding:23px}@media (max-width: 703px){[_nghost-%COMP%]{display:block}}[dir=rtl]   [_nghost-%COMP%]{text-align:right}[_nghost-%COMP%], .context-regular[_nghost-%COMP%]{border-color:var(--message-regular-border-color);background-color:var(--message-regular-background-color)}.context-info[_nghost-%COMP%]{border-color:var(--message-info-border-color);background-color:var(--message-info-background-color)}.context-info[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-info-icon-color)}.context-error[_nghost-%COMP%]{border-color:var(--message-error-border-color);background-color:var(--message-error-background-color)}.context-error[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-error-icon-color)}.context-success[_nghost-%COMP%]{border-color:var(--message-success-border-color);background-color:var(--message-success-background-color)}.context-success[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-success-icon-color)}.context-warning[_nghost-%COMP%]{border-color:var(--message-warning-border-color);background-color:var(--message-warning-background-color)}.context-warning[_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{color:var(--message-warning-icon-color)}@media screen and (forced-colors: active){.nx-message__icon[_ngcontent-%COMP%]{color:CanvasText}}.nx-message__icon[_ngcontent-%COMP%]{margin-right:16px}@media (max-width: 703px){.nx-message__icon[_ngcontent-%COMP%]{float:left;margin-right:8px}}[dir=rtl][_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{float:right;margin-right:initial;margin-left:16px}@media (max-width: 703px){[dir=rtl][_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-message__icon[_ngcontent-%COMP%]{margin-left:8px}}.nx-message--closable[_nghost-%COMP%]{padding-right:47px}[dir=rtl]   .nx-message--closable[_nghost-%COMP%]{padding-right:23px;padding-left:47px}.nx-message__close-icon[_ngcontent-%COMP%]{position:absolute;top:16px;right:16px}[dir=rtl][_nghost-%COMP%]   .nx-message__close-icon[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .nx-message__close-icon[_ngcontent-%COMP%]{right:auto;left:16px}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMessageComponent, [{
    type: Component,
    args: [{
      selector: 'nx-message',
      changeDetection: ChangeDetectionStrategy.OnPush,
      exportAs: 'nxMessage',
      imports: [NxIconModule, NxButtonModule],
      template: "@if (_iconName) {\n    <nx-icon class=\"nx-message__icon\" [name]=\"_iconName\" size=\"s\" aria-hidden=\"true\"> </nx-icon>\n}\n\n@if (closable) {\n    <button\n        nxPlainButton\n        #closeButton\n        (click)=\"_emitCloseEvent()\"\n        [attr.aria-label]=\"closeButtonLabel\"\n        tabindex=\"0\"\n        class=\"nx-message__close-icon\"\n        type=\"button\"\n    >\n        <nx-icon name=\"close\" size=\"s\" aria-hidden=\"true\"> </nx-icon>\n    </button>\n}\n\n<div class=\"nx-message__content\">\n    <ng-content></ng-content>\n</div>\n",
      styles: [":host{font-size:var(--message-font-size);line-height:var(--message-line-height);font-weight:var(--message-font-weight);letter-spacing:var(--message-letter-spacing);color:var(--message-text-color);border-radius:var(--message-border-radius);width:100%;display:flex;align-items:flex-start;text-align:left;position:relative;border:1px solid;padding:23px}@media (max-width: 703px){:host{display:block}}[dir=rtl] :host{text-align:right}:host,:host(.context-regular){border-color:var(--message-regular-border-color);background-color:var(--message-regular-background-color)}:host(.context-info){border-color:var(--message-info-border-color);background-color:var(--message-info-background-color)}:host(.context-info) .nx-message__icon{color:var(--message-info-icon-color)}:host(.context-error){border-color:var(--message-error-border-color);background-color:var(--message-error-background-color)}:host(.context-error) .nx-message__icon{color:var(--message-error-icon-color)}:host(.context-success){border-color:var(--message-success-border-color);background-color:var(--message-success-background-color)}:host(.context-success) .nx-message__icon{color:var(--message-success-icon-color)}:host(.context-warning){border-color:var(--message-warning-border-color);background-color:var(--message-warning-background-color)}:host(.context-warning) .nx-message__icon{color:var(--message-warning-icon-color)}@media screen and (forced-colors: active){.nx-message__icon{color:CanvasText}}.nx-message__icon{margin-right:16px}@media (max-width: 703px){.nx-message__icon{float:left;margin-right:8px}}:host-context([dir=rtl]) .nx-message__icon{float:right;margin-right:initial;margin-left:16px}@media (max-width: 703px){:host-context([dir=rtl]) .nx-message__icon{margin-left:8px}}:host(.nx-message--closable){padding-right:47px}[dir=rtl] :host(.nx-message--closable){padding-right:23px;padding-left:47px}.nx-message__close-icon{position:absolute;top:16px;right:16px}:host-context([dir=rtl]) .nx-message__close-icon{right:auto;left:16px}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1.FocusMonitor
  }], {
    _isInfo: [{
      type: HostBinding,
      args: ['class.context-info']
    }],
    _isSuccess: [{
      type: HostBinding,
      args: ['class.context-success']
    }],
    _isWarning: [{
      type: HostBinding,
      args: ['class.context-warning']
    }],
    _isError: [{
      type: HostBinding,
      args: ['class.context-error']
    }],
    _closeButton: [{
      type: ViewChild,
      args: ['closeButton']
    }],
    context: [{
      type: Input
    }],
    closable: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.nx-message--closable']
    }],
    closeButtonLabel: [{
      type: Input
    }],
    closeEvent: [{
      type: Output,
      args: ['close']
    }]
  });
})();
class NxMessageBannerComponent extends NxMessageComponent {
  /**
   * Sets the context of the message banner. The message box will color accordingly.
   *
   * Default: `'info'`.
   */
  set context(value) {
    this._updateContext(value);
  }
  get context() {
    return this._context;
  }
  constructor(_cdr, _fm) {
    super(_cdr, _fm);
    this._context = 'info';
    this._closable = true;
    this._allowedContexts = ['info', 'error', 'warning'];
  }
  static {
    this.ɵfac = function NxMessageBannerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMessageBannerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FocusMonitor));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxMessageBannerComponent,
      selectors: [["nx-message-banner"]],
      inputs: {
        context: "context"
      },
      exportAs: ["nxMessageBanner"],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 4,
      vars: 2,
      consts: [["closeButton", ""], ["size", "s", "aria-hidden", "true", 1, "nx-message__icon", 3, "name"], ["nxPlainButton", "", "tabindex", "0", "type", "button", 1, "nx-message__close-icon"], [1, "nx-message__content"], ["nxPlainButton", "", "tabindex", "0", "type", "button", 1, "nx-message__close-icon", 3, "click"], ["name", "close", "size", "s", "aria-hidden", "true"]],
      template: function NxMessageBannerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NxMessageBannerComponent_Conditional_0_Template, 1, 1, "nx-icon", 1)(1, NxMessageBannerComponent_Conditional_1_Template, 3, 1, "button", 2);
          i0.ɵɵelementStart(2, "div", 3);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx._iconName ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵconditional(ctx.closable ? 1 : -1);
        }
      },
      dependencies: [NxIconModule, i2.NxIconComponent, NxButtonModule, i3.NxPlainButtonComponent],
      styles: [_c2, "[_nghost-%COMP%]{border-radius:var(--message-banner-border-radius)}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMessageBannerComponent, [{
    type: Component,
    args: [{
      selector: 'nx-message-banner',
      changeDetection: ChangeDetectionStrategy.OnPush,
      exportAs: 'nxMessageBanner',
      imports: [NgIf, NxIconModule, NxButtonModule],
      template: "@if (_iconName) {\n    <nx-icon class=\"nx-message__icon\" [name]=\"_iconName\" size=\"s\" aria-hidden=\"true\"> </nx-icon>\n}\n\n@if (closable) {\n    <button\n        nxPlainButton\n        #closeButton\n        (click)=\"_emitCloseEvent()\"\n        [attr.aria-label]=\"closeButtonLabel\"\n        tabindex=\"0\"\n        class=\"nx-message__close-icon\"\n        type=\"button\"\n    >\n        <nx-icon name=\"close\" size=\"s\" aria-hidden=\"true\"> </nx-icon>\n    </button>\n}\n\n<div class=\"nx-message__content\">\n    <ng-content></ng-content>\n</div>\n",
      styles: [":host{font-size:var(--message-font-size);line-height:var(--message-line-height);font-weight:var(--message-font-weight);letter-spacing:var(--message-letter-spacing);color:var(--message-text-color);border-radius:var(--message-border-radius);width:100%;display:flex;align-items:flex-start;text-align:left;position:relative;border:1px solid;padding:23px}@media (max-width: 703px){:host{display:block}}[dir=rtl] :host{text-align:right}:host,:host(.context-regular){border-color:var(--message-regular-border-color);background-color:var(--message-regular-background-color)}:host(.context-info){border-color:var(--message-info-border-color);background-color:var(--message-info-background-color)}:host(.context-info) .nx-message__icon{color:var(--message-info-icon-color)}:host(.context-error){border-color:var(--message-error-border-color);background-color:var(--message-error-background-color)}:host(.context-error) .nx-message__icon{color:var(--message-error-icon-color)}:host(.context-success){border-color:var(--message-success-border-color);background-color:var(--message-success-background-color)}:host(.context-success) .nx-message__icon{color:var(--message-success-icon-color)}:host(.context-warning){border-color:var(--message-warning-border-color);background-color:var(--message-warning-background-color)}:host(.context-warning) .nx-message__icon{color:var(--message-warning-icon-color)}@media screen and (forced-colors: active){.nx-message__icon{color:CanvasText}}.nx-message__icon{margin-right:16px}@media (max-width: 703px){.nx-message__icon{float:left;margin-right:8px}}:host-context([dir=rtl]) .nx-message__icon{float:right;margin-right:initial;margin-left:16px}@media (max-width: 703px){:host-context([dir=rtl]) .nx-message__icon{margin-left:8px}}:host(.nx-message--closable){padding-right:47px}[dir=rtl] :host(.nx-message--closable){padding-right:23px;padding-left:47px}.nx-message__close-icon{position:absolute;top:16px;right:16px}:host-context([dir=rtl]) .nx-message__close-icon{right:auto;left:16px}\n", ":host{border-radius:var(--message-banner-border-radius)}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i1.FocusMonitor
  }], {
    context: [{
      type: Input
    }]
  });
})();

/**
 * Animations used by the Message Toast.
 * @docs-private
 */
const messageToastAnimations = {
  toastState: trigger('state', [state('initial, void, hidden', style({
    opacity: 0,
    transform: 'translateY(100%)'
  })), state('visible', style({
    opacity: 1
  })), transition('* => visible', animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
    opacity: 1,
    transform: 'translateY(0)'
  }))), transition('* => hidden', animate('300ms cubic-bezier(0, 0, 0.2, 1)', style({
    opacity: 0,
    transform: 'translateY(200%)'
  })))])
};

/**
 * Configuration used when opening a message toast.
 */
class NxMessageToastConfig {
  constructor() {
    /**
     * The politeness level for the LiveAnnouncer announcement.
     *
     * Default: `'polite'`.
     */
    this.politeness = 'polite';
    /**
     * Message to be announced by the LiveAnnouncer. When opening a toast message without a custom
     * component or template, the announcement message will default to the specified message.
     *
     * Default: `''`.
     */
    this.announcementMessage = '';
    /**
     * The length of time in milliseconds to wait before automatically dismissing the message toast.
     *
     * Default: `3000`.
     */
    this.duration = 3000;
    /**
     * Context of the message toast.
     *
     * Default: `'info'`.
     */
    this.context = 'info';
    /** Data being injected into the child component. */
    this.data = null;
  }
}
/**
 * Needed so that the user text data can be injected in the message toast component.
 * @docs-private
 */
class NxMessageToastData {
  constructor(data) {
    this.data = data;
  }
}

/**
 * Internal component that wraps user-provided message toast content.
 * @docs-private
 */
class NxMessageToastComponent extends BasePortalOutlet {
  constructor(_ngZone, _cdr, /** The message toast configuration. */
  config, /** Injected data into the notifciation. */
  data) {
    super();
    this._ngZone = _ngZone;
    this._cdr = _cdr;
    this.config = config;
    this.data = data;
    /** Whether the component has been destroyed. */
    this._destroyed = false;
    /** Subject for notifying that the message toast has exited from view. */
    this._onExit = new Subject();
    /** Subject for notifying that the message toast has finished entering the view. */
    this._onEnter = new Subject();
    /** The state of the message toast animations. */
    this._animationState = 'void';
    /** ARIA role for the message toast container. */
    this._role = null;
    this._context = this.config.context;
    this._setAriaLabels();
  }
  /** Attach a component portal as content to this message toast container. */
  attachComponentPortal(portal) {
    this._assertNotAttached();
    return this._portalOutlet.attachComponentPortal(portal);
  }
  /** Attach a template portal as content to this message toast container. */
  attachTemplatePortal(portal) {
    this._assertNotAttached();
    return this._portalOutlet.attachTemplatePortal(portal);
  }
  /** Handle end of animations, updating the state of the notification. */
  onAnimationEnd(event) {
    const {
      fromState,
      toState
    } = event;
    if (toState === 'void' && fromState !== 'void' || toState === 'hidden') {
      this._completeExit();
    }
    if (toState === 'visible') {
      // Note: we shouldn't use `this` inside the zone callback,
      // because it can cause a memory leak.
      const onEnter = this._onEnter;
      this._ngZone.run(() => {
        onEnter.next();
        onEnter.complete();
      });
    }
  }
  /** Begin animation of message toast entrance into view. */
  enter() {
    if (!this._destroyed) {
      this._animationState = 'visible';
      this._cdr.detectChanges();
      this._cdr.markForCheck();
    }
  }
  /** Begin animation of the message toast exiting from view. */
  exit() {
    // Note: this one transitions to `hidden`, rather than `void`, in order to handle the case
    // where multiple notifications are opened in quick succession (e.g. two consecutive calls to
    // `NxMessageToastService.open`).
    this._animationState = 'hidden';
    this._cdr.markForCheck();
  }
  /** Makes sure the exit callbacks have been invoked when the element is destroyed. */
  ngOnDestroy() {
    this._destroyed = true;
    this._completeExit();
  }
  /**
   * Removes the element in a microtask. Helps prevent errors where we end up
   * removing an element which is in the middle of an animation.
   */
  _completeExit() {
    queueMicrotask(() => {
      this._onExit.next();
      this._onExit.complete();
    });
  }
  /** Asserts that no content is already attached to the container. */
  _assertNotAttached() {
    if (this._portalOutlet.hasAttached()) {
      throw Error('Attempting to attach message toast content after content is already attached');
    }
  }
  _setAriaLabels() {
    // Based on the ARIA spec, `alert` and `status` roles have an
    // implicit `assertive` and `polite` politeness respectively.
    if (this.config.politeness === 'assertive' && !this.config.announcementMessage) {
      this._role = 'alert';
    } else if (this.config.politeness === 'off') {
      this._role = null;
    } else {
      this._role = 'status';
    }
  }
  static {
    this.ɵfac = function NxMessageToastComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMessageToastComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(NxMessageToastConfig), i0.ɵɵdirectiveInject(NxMessageToastData));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxMessageToastComponent,
      selectors: [["nx-message-toast"]],
      viewQuery: function NxMessageToastComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(CdkPortalOutlet, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._portalOutlet = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function NxMessageToastComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵsyntheticHostListener("@state.done", function NxMessageToastComponent_animation_state_done_HostBindingHandler($event) {
            return ctx.onAnimationEnd($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵsyntheticHostProperty("@state", ctx._animationState);
          i0.ɵɵattribute("role", ctx._role);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 3,
      vars: 2,
      consts: [[3, "context"], ["cdkPortalOutlet", ""]],
      template: function NxMessageToastComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "nx-message", 0);
          i0.ɵɵtemplate(1, NxMessageToastComponent_ng_template_1_Template, 0, 0, "ng-template", 1)(2, NxMessageToastComponent_Conditional_2_Template, 1, 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("context", ctx._context);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.data ? 2 : -1);
        }
      },
      dependencies: [NxMessageComponent, CdkPortalOutlet],
      styles: ["nx-message[_ngcontent-%COMP%]{box-shadow:var(--message-box-shadow);max-width:352px;margin-bottom:16px}@media (max-width: 703px){nx-message[_ngcontent-%COMP%]{max-width:calc(100vw - 16px)}}"],
      data: {
        animation: [messageToastAnimations.toastState]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMessageToastComponent, [{
    type: Component,
    args: [{
      selector: 'nx-message-toast',
      host: {
        '[attr.role]': '_role',
        '[@state]': '_animationState',
        '(@state.done)': 'onAnimationEnd($event)'
      },
      animations: [messageToastAnimations.toastState],
      imports: [NxMessageComponent, CdkPortalOutlet],
      template: "<nx-message [context]=\"_context\">\n    <!-- Used when opening from a template -->\n    <ng-template cdkPortalOutlet></ng-template>\n    <!-- Used when opening only with custom text-->\n    @if (data) {\n        {{ data.data }}\n    }\n</nx-message>\n",
      styles: ["nx-message{box-shadow:var(--message-box-shadow);max-width:352px;margin-bottom:16px}@media (max-width: 703px){nx-message{max-width:calc(100vw - 16px)}}\n"]
    }]
  }], () => [{
    type: i0.NgZone
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: NxMessageToastConfig
  }, {
    type: NxMessageToastData
  }], {
    _portalOutlet: [{
      type: ViewChild,
      args: [CdkPortalOutlet, {
        static: true
      }]
    }]
  });
})();
class NxMessageModule {
  static {
    this.ɵfac = function NxMessageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMessageModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxMessageModule,
      imports: [CommonModule, NxIconModule, OverlayModule, PortalModule, NxMessageComponent, NxMessageToastComponent, NxMessageBannerComponent],
      exports: [NxMessageComponent, NxMessageBannerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NxIconModule, OverlayModule, PortalModule, NxMessageComponent, NxMessageToastComponent, NxMessageBannerComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMessageModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NxIconModule, OverlayModule, PortalModule, NxMessageComponent, NxMessageToastComponent, NxMessageBannerComponent],
      exports: [NxMessageComponent, NxMessageBannerComponent]
    }]
  }], null, null);
})();

/** Maximum amount of milliseconds that can be passed into setTimeout. */
const MAX_TIMEOUT = 2 ** 31 - 1;
class NxMessageToastRef {
  constructor(
  /**
   * The instance of the component making up the content of the message toast.
   * @docs-private
   */
  toastInstance, _overlayRef, _componentRef) {
    this.toastInstance = toastInstance;
    this._overlayRef = _overlayRef;
    this._componentRef = _componentRef;
    /** Subject for notifying the user that the message toast has been dismissed. */
    this._afterDismissed = new Subject();
    /** Subject for notifying the user that the message toast has opened and appeared. */
    this._afterOpened = new Subject();
    toastInstance._onExit.pipe(take(1)).subscribe(() => this._finishDismiss());
  }
  /** Dismisses the message toast. */
  dismiss() {
    if (!this._afterDismissed.closed) {
      this.toastInstance.exit();
    }
    clearTimeout(this._durationTimeoutId);
  }
  /** Dismisses the message toast after some duration */
  _dismissAfter(duration) {
    // Note that we need to cap the duration to the maximum value for setTimeout, because
    // it'll revert to 1 if somebody passes in something greater (e.g. `Infinity`). See #17234.
    this._durationTimeoutId = setTimeout(() => this.dismiss(), Math.min(duration, MAX_TIMEOUT));
  }
  /** Marks the message toast as opened */
  _open() {
    if (!this._afterOpened.closed) {
      this._afterOpened.next();
      this._afterOpened.complete();
    }
  }
  /** Cleans up the DOM after closing. */
  _finishDismiss() {
    this._overlayRef.dispose();
    this._afterDismissed.next();
    this._afterDismissed.complete();
  }
  /** Gets an observable that is notified when the message toast is finished closing. */
  afterDismissed() {
    return this._afterDismissed.asObservable();
  }
  /** Gets an observable that is notified when the message toast has opened and appeared. */
  afterOpened() {
    return this.toastInstance._onEnter;
  }
}

/** Injection token that can be used to specify default message toast. */
const NX_MESSAGE_TOAST_DEFAULT_CONFIG = new InjectionToken('NX_MESSAGE_TOAST_DEFAULT_CONFIG');
/** Injection token that can be used to access the data that was passed in to a message toast. */
const NX_MESSAGE_TOAST_COMPONENT_DATA = new InjectionToken('NxMessageToastComponentData');
/** A service for dispatching and displaying toast messages. */
class NxMessageToastService {
  set _oldToastMessageRef(value) {
    if (this._parentMessageToastService) {
      this._parentMessageToastService._oldToastMessageRef = value;
    } else {
      this._toastRefAtThisLevel = value;
    }
  }
  /** Reference to the currently opened message toast at *any* level. */
  get _oldToastMessageRef() {
    const parent = this._parentMessageToastService;
    return parent ? parent._oldToastMessageRef : this._toastRefAtThisLevel;
  }
  constructor(_overlay, _overlayContainer, _injector, _live, _parentMessageToastService, _defaultConfig) {
    this._overlay = _overlay;
    this._overlayContainer = _overlayContainer;
    this._injector = _injector;
    this._live = _live;
    this._parentMessageToastService = _parentMessageToastService;
    this._defaultConfig = _defaultConfig;
    /**
     * Reference to the current message toast in the view *at this level* (in the Angular injector tree).
     * If there is a parent message toast service, all operations should delegate to that parent
     * via `_oldToastMessageRef`.
     */
    this._toastRefAtThisLevel = null;
    this._initializeWrapper();
  }
  /**
   * Initializes the wrapper element for toast message in the overlay container.
   * Create a wrapper with ARIA attributes for accessibility
   */
  _initializeWrapper() {
    const overlayContainer = this._overlayContainer.getContainerElement();
    if (!overlayContainer.querySelector('#nx-toast-message-region')) {
      const wrapperElement = document.createElement('div');
      wrapperElement.setAttribute('aria-live', 'polite');
      wrapperElement.setAttribute('aria-atomic', 'true');
      wrapperElement.id = 'nx-toast-message-region';
      overlayContainer.appendChild(wrapperElement);
    }
  }
  /**
   * Creates and dispatches a message toast with a custom text.
   * @param text Text to be used for the message toast.
   * @param config Extra configuration for the message toast.
   */
  open(text, config) {
    const currentConfig = {
      ...new NxMessageToastConfig(),
      ...this._defaultConfig,
      ...config
    };
    const overlayRef = this._createOverlay(currentConfig);
    const injector = this._createInjector(currentConfig, new NxMessageToastData(text), this._injector);
    const componentPortal = new ComponentPortal(NxMessageToastComponent, undefined, injector);
    const componentRef = overlayRef.attach(componentPortal);
    const toastRef = new NxMessageToastRef(componentRef.instance, overlayRef, null);
    this._animateToast(toastRef, currentConfig);
    this._oldToastMessageRef = toastRef;
    return this._oldToastMessageRef;
  }
  /**
   * Creates and dispatches a message toast with a custom template for the content.
   * @param template Template to be used for the message toast.
   * @param config Extra configuration for the message toast.
   */
  openFromTemplate(template, config) {
    const currentConfig = {
      ...new NxMessageToastConfig(),
      ...this._defaultConfig,
      ...config
    };
    const overlayRef = this._createOverlay(currentConfig);
    const container = this._attachToastComponent(overlayRef, currentConfig);
    const toastRef = new NxMessageToastRef(container, overlayRef, null);
    const portal = new TemplatePortal(template, null, {
      $implicit: currentConfig.data,
      toastRef
    });
    container.attachTemplatePortal(portal);
    this._animateToast(toastRef, currentConfig);
    this._oldToastMessageRef = toastRef;
    return this._oldToastMessageRef;
  }
  /**
   * Creates and dispatches a message toast using a component for the content.
   * @param component Component to be used for the message toast.
   * @param config Extra configuration for the message toast.
   */
  openFromComponent(component, config) {
    const currentConfig = {
      ...new NxMessageToastConfig(),
      ...this._defaultConfig,
      ...config
    };
    const overlayRef = this._createOverlay(currentConfig);
    const container = this._attachToastComponent(overlayRef, currentConfig);
    const portal = new ComponentPortal(component, null);
    const componentRef = container.attachComponentPortal(portal);
    const toastRef = new NxMessageToastRef(container, overlayRef, componentRef);
    this._animateToast(toastRef, currentConfig);
    this._oldToastMessageRef = toastRef;
    return this._oldToastMessageRef;
  }
  // Attaches the message toast container component to the overlay.
  _attachToastComponent(overlayRef, config) {
    const injector = this._createInjector(config, null, this._injector);
    const containerPortal = new ComponentPortal(NxMessageToastComponent, null, injector);
    const containerRef = overlayRef.attach(containerPortal);
    containerRef.instance.config = config;
    return containerRef.instance;
  }
  // Creates a new overlay and places it in the correct place.
  _createOverlay(config) {
    const overlayConfig = new OverlayConfig();
    const positionStrategy = this._overlay.position().global();
    positionStrategy.bottom('0');
    positionStrategy.centerHorizontally();
    overlayConfig.positionStrategy = positionStrategy;
    const overlayRef = this._overlay.create(overlayConfig);
    const overlayElement = overlayRef.overlayElement.parentElement;
    const wrapper = this._overlayContainer.getContainerElement().querySelector('#nx-toast-message-region');
    if (overlayElement) {
      wrapper?.appendChild(overlayElement);
    }
    if (config.announcementMessage) {
      // Hide element when announcement message is there
      overlayElement?.setAttribute('aria-hidden', 'true');
    }
    return overlayRef;
  }
  /** Animates the old message toast out and the new one in. */
  _animateToast(toastRef, config) {
    // When the message toast is dismissed, clear the reference to it.
    toastRef.afterDismissed().subscribe(() => {
      // Clear the message toast ref if it hasn't already been replaced by a newer message toast.
      if (this._oldToastMessageRef === toastRef) {
        this._oldToastMessageRef = null;
      }
      if (config.announcementMessage) {
        this._live.clear();
      }
    });
    if (this._oldToastMessageRef) {
      // If a message toast is opened, dismiss it and enter the
      // new message toast after exit animation is complete.
      this._oldToastMessageRef.afterDismissed().subscribe(() => {
        toastRef.toastInstance.enter();
      });
      this._oldToastMessageRef.dismiss();
    } else {
      // If no message toast is in view, enter the message toast.
      toastRef.toastInstance.enter();
    }
    // If a message toast duration is provided, set up dismiss based on after the message toast is opened.
    if (config.duration && config.duration > 0) {
      toastRef.afterOpened().subscribe(() => toastRef._dismissAfter(config.duration));
    }
    if (config.announcementMessage) {
      this._live.announce(config.announcementMessage, config.politeness);
    }
  }
  _createInjector(config, data, injector) {
    return Injector.create({
      parent: injector,
      providers: [{
        provide: NxMessageToastConfig,
        useValue: config
      }, {
        provide: NxMessageToastData,
        useValue: data
      }, {
        provide: NX_MESSAGE_TOAST_COMPONENT_DATA,
        useValue: config.data
      }],
      name: 'nx-message-toast__portal-injector'
    });
  }
  /**
   * Dismisses the currently visible message toast.
   */
  dismiss() {
    if (this._oldToastMessageRef) {
      this._oldToastMessageRef.dismiss();
    }
  }
  ngOnDestroy() {
    if (this._toastRefAtThisLevel) {
      this._toastRefAtThisLevel.dismiss();
    }
  }
  static {
    this.ɵfac = function NxMessageToastService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxMessageToastService)(i0.ɵɵinject(i1$1.Overlay), i0.ɵɵinject(i1$1.OverlayContainer), i0.ɵɵinject(i0.Injector), i0.ɵɵinject(i1.LiveAnnouncer), i0.ɵɵinject(NxMessageToastService, 12), i0.ɵɵinject(NX_MESSAGE_TOAST_DEFAULT_CONFIG, 8));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxMessageToastService,
      factory: NxMessageToastService.ɵfac,
      providedIn: NxMessageModule
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxMessageToastService, [{
    type: Injectable,
    args: [{
      providedIn: NxMessageModule
    }]
  }], () => [{
    type: i1$1.Overlay
  }, {
    type: i1$1.OverlayContainer
  }, {
    type: i0.Injector
  }, {
    type: i1.LiveAnnouncer
  }, {
    type: NxMessageToastService,
    decorators: [{
      type: Optional
    }, {
      type: SkipSelf
    }]
  }, {
    type: NxMessageToastConfig,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [NX_MESSAGE_TOAST_DEFAULT_CONFIG]
    }]
  }], null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NX_MESSAGE_TOAST_COMPONENT_DATA, NX_MESSAGE_TOAST_DEFAULT_CONFIG, NxMessageBannerComponent, NxMessageComponent, NxMessageModule, NxMessageToastComponent, NxMessageToastConfig, NxMessageToastData, NxMessageToastRef, NxMessageToastService, messageToastAnimations };
